import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import { Counter } from '@common/components/Filters/Filters.styled';
import { ColorFilterRow } from '@common/components/Filters/FiltersRows';
import {
  CategoryTitle,
  CategoryTitleContainer,
  FilterCategory,
  FiltersList,
  FiltersListBackButton,
  FiltersListContainer,
  FiltersListTitle,
  FiltersListTitleContainer,
  LoadingFilters,
  MobileFiltersListContainer,
  MobileSubmenuIcon,
} from '@common/components/Filters/FiltersSections/FiltersSection.styled';
import * as Icons from '@common/components/Icons';
import LoadingIndicator from '@common/components/LoadingIndicator';
import { COLORS_SECTION } from '@common/constants/filters';
import ColorIcon from '@common/components/ColorIcon';

function ColorsFiltersSection({
  openSection,
  closeSection,
  selectedColors,
  visibleMobileSection,
  allFiltersCount,
  transitionState,
  isFetching,
  colorOptions,
  onItemSelect,
}) {
  const { t } = useTranslation();

  return (
    <FilterCategory>
      <CategoryTitleContainer onClick={() => openSection(COLORS_SECTION)}>
        <CategoryTitle>{t('filters.colorsTitle', 'Farbe')}</CategoryTitle>
        {selectedColors.length > 0 && (
          <Counter data-testid="colorsFiltersCounter">
            {selectedColors.length}
          </Counter>
        )}
        <MobileSubmenuIcon>
          <Icons.ArrowForwardNavigation />
        </MobileSubmenuIcon>
      </CategoryTitleContainer>
      <FiltersListContainer
        transitionState={transitionState}
        isMobileSectionOpen={visibleMobileSection === COLORS_SECTION}
        hasFiltersSelected={allFiltersCount > 0}
      >
        <FiltersListTitleContainer>
          <FiltersListBackButton
            onClick={() => {
              closeSection();
            }}
          >
            <Icons.ArrowBackwardNavigation
              width="11"
              height="20"
            />
          </FiltersListBackButton>
          <FiltersListTitle>
            {t('filters.colorsTitle', 'Farbe')}
          </FiltersListTitle>
          {selectedColors.length > 0 && (
            <Counter>{selectedColors.length}</Counter>
          )}
        </FiltersListTitleContainer>

        <MobileFiltersListContainer>
          <FiltersList>
            {isFetching && (
              <LoadingFilters>
                <LoadingIndicator />
              </LoadingFilters>
            )}
            {!isFetching &&
              colorOptions.map(option => (
                <ColorFilterRow
                  icon={<ColorIcon color={option.colorhex} />}
                  key={`${option.id}-${option.colorhex}`}
                  title={option.title}
                  value={option.id}
                  itemsCount={option.count}
                  selected={selectedColors.includes(option.id)}
                  onSelect={onItemSelect}
                />
              ))}
          </FiltersList>
        </MobileFiltersListContainer>
      </FiltersListContainer>
    </FilterCategory>
  );
}

ColorsFiltersSection.defaultProps = {
  isFetching: false,
  visibleMobileSection: null,
};

ColorsFiltersSection.propTypes = {
  allFiltersCount: PropTypes.number.isRequired,
  closeSection: PropTypes.func.isRequired,
  colorOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isFetching: PropTypes.bool,
  onItemSelect: PropTypes.func.isRequired,
  openSection: PropTypes.func.isRequired,
  selectedColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  transitionState: PropTypes.string.isRequired,
  visibleMobileSection: PropTypes.string,
};

export { ColorsFiltersSection };
